document.addEventListener("DOMContentLoaded", () => {
  console.log("tester.js loaded");

  const tester = document.getElementById("tester");
  const timelineSection = document.getElementById("timeline");
  const timelineEntryMarkers = [...document.querySelectorAll(".timeline-entry-marker")];
  const timelineEntrySections = [...document.querySelectorAll("#timeline .timeline-section[data-slug]")];
  const fontWeight = document.getElementById("fontWeight");
  const fontWidth = document.getElementById("fontWidth");
  const xHeight = document.getElementById("xHeight");
  const styleSelect = document.getElementById("style");
  const resetBtn = document.getElementById("resetBtn");

  const fontWeightValue = document.getElementById("fontWeightValue");
  const fontWidthValue = document.getElementById("fontWidthValue");
  const xHeightValue = document.getElementById("xHeightValue");

  if (!tester || !fontWeight || !fontWidth || !xHeight || !resetBtn) {
    console.warn("Tester elements missing");
    return;
  }

  const testerWordListPaths = [
    "/words/dunbar.txt"
  ];
  const fallbackPresetTexts = [
    "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    "abcdefghijklmnopqrstuvwxyz",
    "0123456789",
    ".,:;!?&@#%*()[]{}+-=/",
    "The quick brown fox jumps over the lazy dog.",
    "Various alternate characters."
  ];
  let presetTexts = fallbackPresetTexts;
  let testerHasUserText = false;
  let scrollTextStep = 0;
  let scrollTextFrameRequested = false;
  const scrollTextStepCount = 4;

  const weightStops = [100, 300, 500, 700, 800, 900];
  
  //avoid linebreaks
  tester.addEventListener("keydown", (e) => {
  if (e.key === "Enter") {
    e.preventDefault();
  }
});
tester.addEventListener("paste", (e) => {
  e.preventDefault();
  testerHasUserText = true;
  const text = (e.clipboardData || window.clipboardData)
    .getData("text")
    .replace(/[\r\n]+/g, " ");

  document.execCommand("insertText", false, text);
});

  function parseWordList(data) {
    return data
      .replace(/^\/\/.+$/mg, "")
      .replace(/(^|\n)\/\*[^]*?\*\/($|\n)/g, "\n")
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean)
      .flatMap((line) => line.split("|").map((word) => word.trim()).filter(Boolean));
  }

  async function loadPresetTexts() {
    try {
      const lists = await Promise.all(
        testerWordListPaths.map(async (path) => {
          const response = await fetch(path);
          if (!response.ok) {
            throw new Error(`Unable to load ${path}`);
          }
          return response.text();
        })
      );
      const nextPresetTexts = lists.flatMap(parseWordList);

      if (nextPresetTexts.length) {
        presetTexts = nextPresetTexts;
      }
    } catch (error) {
      console.warn("Using fallback tester presets:", error);
    }
  }

  function getRandomPreset(currentText = "") {
    if (presetTexts.length < 2) return presetTexts[0] || "";

    let nextText = currentText;
    let attempts = 0;

    while (nextText === currentText && attempts < 8) {
      nextText = presetTexts[Math.floor(Math.random() * presetTexts.length)];
      attempts += 1;
    }

    return nextText;
  }

  function syncStyleDropdownToWeight() {
    if (!styleSelect) return;

    const weight = Number(fontWeight.value);
    const nearestWeight = weightStops.reduce((nearest, current) => {
      return Math.abs(current - weight) < Math.abs(nearest - weight)
        ? current
        : nearest;
    }, weightStops[0]);

    styleSelect.value = String(nearestWeight);
  }

  function syncWeightToStyleDropdown() {
    if (!styleSelect) return;

    fontWeight.value = styleSelect.value;
  }

  function updateValueLabels() {
    if (fontWeightValue) fontWeightValue.textContent = fontWeight.value;
    if (fontWidthValue) fontWidthValue.textContent = fontWidth.value;
    if (xHeightValue) xHeightValue.textContent = xHeight.value;
  }

  function updateTesterStyles() {
    tester.style.fontWeight = fontWeight.value;
    tester.style.fontVariationSettings =
      `"wght" ${fontWeight.value}, "wdth" ${fontWidth.value}, "XHGT" ${xHeight.value}`;

    updateValueLabels();

    console.log("fontVariationSettings:", tester.style.fontVariationSettings);
  }

function autoResizeText() {
  const text = tester.textContent.trim();
  const isMobile = window.matchMedia("(max-width: 640px)").matches;
  const baseSize = isMobile ? 44 : 90;
  const minSize = isMobile ? 14 : 18;
  const maxSize = isMobile ? 72 : 320;
  const availableWidth = tester.offsetWidth * 0.95;

  if (!text.length) {
    tester.style.fontSize = `${baseSize}px`;
    return;
  }

  tester.style.fontSize = `${baseSize}px`;

  const range = document.createRange();
  range.selectNodeContents(tester);
  const rect = range.getBoundingClientRect();

  if (!rect.width) return;

  let scale = availableWidth / rect.width;

  if (text.length <= 2) {
    scale *= 1.1;
  } else if (text.length <= 6) {
    scale *= 1.05;
  }

  const newSize = Math.max(minSize, Math.min(baseSize * scale, maxSize));
  tester.style.fontSize = `${newSize}px`;
}

function updateBaseline() {
  const marker = document.createElement("span");
  marker.textContent = "x";
  marker.style.display = "inline-block";
  marker.style.padding = "0";
  marker.style.margin = "0";
  marker.style.lineHeight = "1";
  marker.style.visibility = "hidden";

  tester.appendChild(marker);

  const markerRect = marker.getBoundingClientRect();
  const testerRect = tester.getBoundingClientRect();
  const baseline = markerRect.bottom - testerRect.top;

  tester.style.setProperty("--baseline", `${baseline}px`);
  marker.remove();
}

function refreshTesterLayout() {
  updateTesterStyles();
  autoResizeText();
  updateBaseline();
}

function setRandomTesterText() {
  tester.textContent = getRandomPreset(tester.textContent.trim());
  refreshTesterLayout();
}

function updateTesterTextOnScroll() {
  scrollTextFrameRequested = false;
  if (!timelineSection || testerHasUserText || !timelineEntryMarkers.length) return;

  const timelineRect = timelineSection.getBoundingClientRect();
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

  if (timelineRect.bottom <= 0 || timelineRect.top >= viewportHeight) {
    return;
  }

  const passedEntryCount = timelineEntrySections.length
    ? timelineEntrySections.filter((section) => {
        return section.getBoundingClientRect().top <= viewportHeight * 0.5;
      }).length
    : Math.round(
        Math.min(
          1,
          Math.max(0, (viewportHeight - timelineRect.top) / (viewportHeight + timelineRect.height))
        ) * timelineEntryMarkers.length
      );

  const nextStep = Math.min(
    scrollTextStepCount,
    Math.floor((passedEntryCount * scrollTextStepCount) / timelineEntryMarkers.length)
  );

  if (nextStep !== scrollTextStep) {
    scrollTextStep = nextStep;
    setRandomTesterText();
  }
}

function requestTesterTextScrollUpdate() {
  if (scrollTextFrameRequested) return;
  scrollTextFrameRequested = true;
  window.requestAnimationFrame(updateTesterTextOnScroll);
}

tester.textContent = getRandomPreset();

loadPresetTexts().then(() => {
  if (!testerHasUserText) {
    setRandomTesterText();
  }
});

tester.addEventListener("beforeinput", () => {
  testerHasUserText = true;
});

tester.addEventListener("input", () => {
  testerHasUserText = true;
  refreshTesterLayout();
});

fontWeight.addEventListener("input", () => {
  syncStyleDropdownToWeight();
  refreshTesterLayout();
});

fontWidth.addEventListener("input", refreshTesterLayout);
xHeight.addEventListener("input", refreshTesterLayout);

fontWeight.addEventListener("change", refreshTesterLayout);
fontWidth.addEventListener("change", refreshTesterLayout);
xHeight.addEventListener("change", refreshTesterLayout);

if (styleSelect) {
  styleSelect.addEventListener("change", () => {
    syncWeightToStyleDropdown();
    refreshTesterLayout();
  });
}

resetBtn.addEventListener("click", () => {
  testerHasUserText = false;
  scrollTextStep = 0;
  fontWeight.value = 500;
  fontWidth.value = 100;
  xHeight.value = 460;
  if (styleSelect) styleSelect.value = "500";
  setRandomTesterText();
});

window.addEventListener("scroll", requestTesterTextScrollUpdate, { passive: true });
window.addEventListener("resize", () => {
  refreshTesterLayout();
  requestTesterTextScrollUpdate();
});

refreshTesterLayout();
});
